import {Poi, PoiGroup} from '../../../react-app-env';
import React, {ReactNode} from 'react';
import SidebarHeader, {buildPopStackButton} from '../../sidebar/SidebarHeader';
import {SidebarPage} from '../../sidebar/SidebarPage';
import {StackApi} from '../../stack/Stack.types';
import ListView from '../../listview/ListView';
import ListViewGroup from '../../listview/listviewgroup/ListViewGroup';
import ListViewItem from '../../listview/listviewitem/ListViewItem';
import {noop} from '../../../utils/Utils';
import {i18n} from '../../../i18n/i18n';
import {IconSizes} from '../../icon/Icon';
import SidebarScrollableContent from '../../sidebar/SidebarScrollableContent';
import {Events, EventType} from '../../../events/Events';
import {ListViewItemDecoration, ListViewItemDecorationIcon} from '../../listview/listviewitem/ListViewItem.types';
import {useTrip} from '../../context/TripContext';

export interface PoiGroupSidebarPageProps {
  readonly poi: Poi;
  readonly stackApi: StackApi;
}

function PoiGroupSidebarPage({ poi, stackApi }: PoiGroupSidebarPageProps){
  const trip = useTrip();

  function renderPoiGroup(poiGroup: PoiGroup): ReactNode {
    const isCurrentGroup = poiGroup.id === poi.groupId;
    const iconCategory = isCurrentGroup ? 'fa-folder' : 'fa-folder fa-regular';
    const decoration: ListViewItemDecoration = {
      icon: isCurrentGroup ? ListViewItemDecorationIcon.OPTION_SELECTED : ListViewItemDecorationIcon.OPTION_EMPTY,
      size: IconSizes.MEDIUM
    };

    const poiCount = trip.pois.filter(p => p.groupId === poiGroup.id).length;
    const poiCountLabel = poiCount === 1
        ? i18n().global.poiCountSingular.replace('%count%', poiCount.toString())
        : i18n().global.poiCountPlural.replace('%count%', poiCount.toString());

    return <ListViewItem key={poiGroup.id}
                         title={poiGroup.title}
                         iconCategory={iconCategory}
                         decoration={decoration}
                         onClick={() => noop()}
                         bottomAffix={{ label: poiCountLabel }}/>;
  }

  function getSortedPoiGroups(): PoiGroup[] {
    return trip.poiGroups.sort((a, b) => a.tripPosition - b.tripPosition);
  }

  function onHighlightInItineraryClicked() {
    Events.publish(EventType.HIGHLIGHT_POI, poi);
  }

  return <SidebarPage className="poi-group">
    <SidebarHeader
        title={i18n().poiDetails.poiGroup.title}
        subtitle={poi.title}
        buttons={[
          buildPopStackButton(() => stackApi.pop())
        ]}/>
    <SidebarScrollableContent>
      <ListView>
        <ListViewGroup>
          <ListViewItem title={i18n().poiDetails.poiGroup.highlightInItinerary}
                        bottomAffix={{ label: i18n().poiDetails.poiGroup.highlightInItineraryDetails }}
                        iconCategory={'fa-location-crosshairs'}
                        onClick={() => onHighlightInItineraryClicked()}/>
        </ListViewGroup>
        <ListViewGroup>
          {getSortedPoiGroups().map(group => renderPoiGroup(group))}
        </ListViewGroup>
      </ListView>
    </SidebarScrollableContent>
  </SidebarPage>;
}

export default PoiGroupSidebarPage;
